// Main.js file.
// IIFE - Immediately Invoked Function Expression
(function (fastighetsunderhall) {
    // The global jQuery object is passed as a parameter
    fastighetsunderhall(window.jQuery, window, document);
}(function ($, window, document) {
    // The $ is now locally scoped
    // Listen for the jQuery ready event on the document
    $('#menu-primary-menu .menu-item-has-children >a').click(function (e) {
        e.preventDefault();
        $(this).parent().find('.sub-menu').slideToggle(300);
        $(this).parent().toggleClass('menu-is-open');
    });

    //Diferent logo on homnepage
    if($('body').hasClass('home')) {
        $('.logo img').attr('src', '/wp-content/uploads/2019/06/logo-white.svg');
    }

    $('.menu-204 select').select2();


    //Smooth scroll
    $('#menu-primary-menu li:last-child a[href^="#"]').click(function () {
        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top
        }, 500);

        return false;
    });
    //Smooth scroll
    $('#menu-primary-menu-1 li:last-child a[href^="#"]').click(function () {
        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top
        }, 500);

        if($(window).width() < 1024) {
            document.body.classList.remove('nav-is-toggled');
        }
        return false;
    });
    //Header scroll

    $(window).scroll(function(){
        if($(document).scrollTop() > 0) {
            $('body:not(.logged-in) header').addClass('small');
            $('body:not(.logged-in)').addClass('header-fixed');
            $('body:not(.logged-in).home .logo img').attr('src', 'wp-content/uploads/sites/2/2020/12/Logo-Color-.svg');
        } else {
            $('body:not(.logged-in) header').removeClass('small');
            $('body:not(.logged-in)').removeClass('header-fixed');
            $('body:not(.logged-in).home .logo img').attr('src', '/wp-content/uploads/2019/06/logo-white.svg');

        }
    });

    //Mob menu


    if($(window).width() < 1024) {
    const navExpand = [].slice.call(document.querySelectorAll('.menu-item-has-children'));
    const backLink = `<li class="menu-item">
	<a class="nav-link nav-back-link" href="javascript:;">
		Back
	</a>
</li>`;

    navExpand.forEach(item => {
        item.querySelector('.sub-menu').insertAdjacentHTML('afterbegin', backLink);
        item.querySelector('.menu-item a').addEventListener('click', (event) =>{ event.preventDefault(); item.classList.add('active')});
        item.querySelector('.nav-back-link').addEventListener('click', () => item.classList.remove('active'));
    });

// ---------------------------------------
// not-so-important stuff starts here

    const ham = document.getElementById('ham');
    ham.addEventListener('click', function() {
        document.body.classList.toggle('nav-is-toggled')
    })
    }



    $('.news_button_wrapper a').click(function (e) {
        e.preventDefault();
        if($(this).hasClass('btn-facebook')) {
            $('.widget-wrapper').hide();
            $('.widget-wrapper-facebook').show();
        }
        if($(this).hasClass('btn-instagram')) {
            $('.widget-wrapper').hide();
            $('.widget-wrapper-instagram').show();
        }
    })




}));
